/**
 * @generated SignedSource<<471bd6285f3de29323577ebe6604ae73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AiGenerationInput = {
  materials?: ReadonlyArray<AiGenerationMaterialsInput | null> | null;
  meshes?: ReadonlyArray<AiGenerationMeshesInput | null> | null;
  prompt?: string | null;
};
export type AiGenerationMaterialsInput = {
  id?: string | null;
  name?: string | null;
};
export type AiGenerationMeshesInput = {
  id?: string | null;
  name?: string | null;
  parentID?: string | null;
};
export type composerQueriesGenerateAiAttributesQuery$variables = {
  input: AiGenerationInput;
};
export type composerQueriesGenerateAiAttributesQuery$data = {
  readonly generatedAIAttributes: {
    readonly attributes: ReadonlyArray<{
      readonly an: string | null;
      readonly o: ReadonlyArray<{
        readonly a: ReadonlyArray<{
          readonly m: ReadonlyArray<string | null> | null;
          readonly mat: string | null;
          readonly t: string | null;
        } | null> | null;
        readonly on: string | null;
      } | null> | null;
    } | null> | null;
  };
};
export type composerQueriesGenerateAiAttributesQuery = {
  response: composerQueriesGenerateAiAttributesQuery$data;
  variables: composerQueriesGenerateAiAttributesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateAttributesByPromptResult",
    "kind": "LinkedField",
    "name": "generatedAIAttributes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GenerateAttributesByPromptAttributes",
        "kind": "LinkedField",
        "name": "attributes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "an",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GenerateAttributeByPromptOptions",
            "kind": "LinkedField",
            "name": "o",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GenerateAttributeByPromptActions",
                "kind": "LinkedField",
                "name": "a",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "t",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "m",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mat",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "on",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "composerQueriesGenerateAiAttributesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "composerQueriesGenerateAiAttributesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0d7dcb4f1eabbb90fde7a1c41bb1dfc3",
    "id": null,
    "metadata": {},
    "name": "composerQueriesGenerateAiAttributesQuery",
    "operationKind": "query",
    "text": "query composerQueriesGenerateAiAttributesQuery(\n  $input: AiGenerationInput!\n) {\n  generatedAIAttributes(input: $input) {\n    attributes {\n      an\n      o {\n        a {\n          t\n          m\n          mat\n        }\n        on\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "57f6b8dc3b17d0748cc6aac6b99fe421";

export default node;
